import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsAgentStudioRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-agent-studio',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent',
	exact: true,
};
